import { COMPANY } from "../lib/content";

const SECTIONS = [
    {
        title: "1. How Billing Works",
        body: `WorkAssign AI (${COMPANY.legal}) offers two billing models: a prepaid recharge for Small Business users and a monthly subscription for Enterprise customers. The applicable model is always shown clearly on the plan before you pay.`,
    },
    {
        title: "2. Prepaid Recharge (Small Business)",
        body: "The ₹499 recharge adds usage balance to your account. You choose one option per recharge — 50 AI calling minutes (Option A) or 500 WhatsApp messages (Option B); both are not included together. Balance is deducted only on real, billable usage — no enquiry means no usage charge. There is no mandatory monthly subscription and no automatic recharge.",
    },
    {
        title: "3. Channels & Usage Metering",
        body: "AI calling is metered per minute of connected call time. Messaging is metered per WhatsApp message sent by the AI agent — SMS is a separate channel and is not included in the WhatsApp message allowance. Usage rates are shared with you transparently before activation.",
    },
    {
        title: "4. Monthly Subscription (Enterprise)",
        body: "Enterprise Premium is billed monthly in advance. Calling minutes and message allowances are configured with our team before activation, and usage beyond configured limits is charged only on actual consumption. GST invoice is issued for every payment.",
    },
    {
        title: "5. AI Calling & WhatsApp Consent",
        body: "Our AI agents call or message only the customers and leads provided by your business, and every AI call begins with a clear disclosure that the caller is an AI assistant. You are responsible for ensuring you have the consent of your customers to be contacted, as required by applicable telecom and data-protection regulations (including TRAI guidelines in India).",
    },
    {
        title: "6. Failed Payments & Balance",
        body: "If a payment fails, no balance is added and no amount is deducted from you beyond what your bank confirms. Any deducted amount for a failed recharge is auto-refunded by the payment gateway as per its timeline.",
    },
    {
        title: "7. Contact",
        body: "For billing questions, reach us via the Contact page or on WhatsApp at " + COMPANY.phoneDisplay + ".",
    },
];

export default function Billing() {
    return (
        <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:py-24" data-testid="billing-page">
            <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-cyan-400">Legal</p>
            <h1 className="mt-3 font-display text-4xl font-extrabold text-white" data-testid="billing-heading">Billing & Usage Policy</h1>
            <p className="mt-3 text-sm text-slate-500">Last updated: October 2026 · {COMPANY.legal}</p>
            <div className="mt-10 space-y-8">
                {SECTIONS.map((s) => (
                    <section key={s.title} data-testid={`billing-section-${s.title.split(".")[0]}`}>
                        <h2 className="font-display text-lg font-bold text-white">{s.title}</h2>
                        <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{s.body}</p>
                    </section>
                ))}
            </div>
        </div>
    );
}
